class AccordionGroup extends HTMLElement {
  constructor() {
    super();

    this.items = [];
    this.handleHeaderClick = this.handleHeaderClick.bind(this);
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll(".accordion__item"));

    this.items.forEach((item) => {
      const header = item.querySelector(".accordion__header");

      if (!header) return;

      header.addEventListener("click", this.handleHeaderClick);
    });

    this.setInitialState();
  }

  disconnectedCallback() {
    this.items.forEach((item) => {
      const header = item.querySelector(".accordion__header");

      if (!header) return;

      header.removeEventListener("click", this.handleHeaderClick);
    });
  }

  handleHeaderClick(event) {
    const header = event.currentTarget;
    const item = header.closest(".accordion__item");
    const content = item ? item.querySelector(".accordion__content") : null;

    if (!item || !content) return;

    this.closeOthers(item);
    this.toggleItem(item, content);
  }

  setInitialState() {
    let hasOpenedItem = false;

    this.items.forEach((item) => {
      const content = item.querySelector(".accordion__content");
      const header = item.querySelector(".accordion__header");
      const shouldOpen = item.classList.contains("active") && !hasOpenedItem;

      if (!content || !header) return;

      if (shouldOpen) {
        hasOpenedItem = true;
        this.openItem(item, content);
      } else {
        this.closeItem(item, content);
      }
    });
  }

  closeOthers(currentItem) {
    this.items.forEach((item) => {
      if (item === currentItem) return;

      const content = item.querySelector(".accordion__content");

      if (!content) return;

      this.closeItem(item, content);
    });
  }

  toggleItem(item, content) {
    const isActive = item.classList.contains("active");

    if (isActive) {
      this.closeItem(item, content);
    } else {
      this.openItem(item, content);
    }
  }

  openItem(item, content) {
    const header = item.querySelector(".accordion__header");

    item.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";

    if (header) {
      header.setAttribute("aria-expanded", "true");
    }
  }

  closeItem(item, content) {
    const header = item.querySelector(".accordion__header");

    item.classList.remove("active");
    content.style.maxHeight = null;

    if (header) {
      header.setAttribute("aria-expanded", "false");
    }
  }
}

if (!customElements.get("accordion-group")) {
  customElements.define("accordion-group", AccordionGroup);
}
